// extracted by mini-css-extract-plugin
export default {"root":"o1Y0X4A9","active":"D8ThljDW","appr":"hXtSxiR2","cheatsheetLink":"mzA6uoVK"};